export default __webpack_public_path__ + "static/media/expand.cdf95f59.svg";